import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ProgressSegment } from '../../../models/progress-segment.model';

@Component({
  standalone: true,
  selector: 'eiq-progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltipModule]
})
export class ProgressBarComponent {
  segments = input.required<ProgressSegment[]>();
  max = input<number>(100);

  normalizedSegments$ = computed(() => {
    const max = this.max() || 0;

    return this.segments().map((segment) => ({
      ...segment,
      value: max > 0 ? (segment.value / max) * 100 : 0
    }));
  });

  total$ = computed(() => Math.round(this.normalizedSegments$().reduce((sum, segment) => (segment.excludeFromTotal ? sum : sum + segment.value), 0)));
}
